module.exports = __webpack_public_path__ + "media/images/icon-question-15030cfcd5bef7f9015573c0e8003a31.png";